export default {
	loading      : false,
	userState    : null,
	userPromoCode: '',
	userQrcode   : '',
	userAuth     : null
}
